import React, { useState } from 'react';
import LastHPMatchesTable from './LastHPMatchesTable';
import '../styles/MapPerformanceTable.css';

const HPMatchDropdown = ({ matches, limit, onLimitChange, mapOptions, selectedMap, onMapChange }) => {
  const [expanded, setExpanded] = useState(false);

  const filteredMatches = selectedMap
    ? matches
        .filter(m => m.Map === selectedMap)
        .sort((a, b) => new Date(b.Date) - new Date(a.Date))
    : matches.sort((a, b) => new Date(b.Date) - new Date(a.Date));
  const stopControlPropagation = (event) => {
    event.stopPropagation();
  };

  return (
    <div className="last-games-panel">
      <div
        className={`last-games-header ${expanded ? 'expanded' : ''}`}
        onClick={() => setExpanded(!expanded)}
      >
        <span className="last-games-title">Last {limit} HP Games</span>

        <div
          className="last-games-controls"
          onClick={stopControlPropagation}
          onMouseDown={stopControlPropagation}
          onPointerDown={stopControlPropagation}
        >
          <select
            value={selectedMap}
            onChange={(e) => onMapChange(e.target.value)}
            onClick={stopControlPropagation}
            onMouseDown={stopControlPropagation}
            onPointerDown={stopControlPropagation}
          >
            <option value="">All Maps</option>
            {mapOptions.map((map, idx) => (
              <option key={idx} value={map}>{map}</option>
            ))}
          </select>

          <select
            value={limit}
            onChange={(e) => onLimitChange(Number(e.target.value))}
            onClick={stopControlPropagation}
            onMouseDown={stopControlPropagation}
            onPointerDown={stopControlPropagation}
          >
            <option value="5">Last 5</option>
            <option value="10">Last 10</option>
            <option value="15">Last 15</option>
            <option value="20">Last 20</option>
          </select>

          <button
            type="button"
            className="last-games-caret"
            onClick={(event) => {
              event.stopPropagation();
              setExpanded(!expanded);
            }}
            onMouseDown={stopControlPropagation}
            onPointerDown={stopControlPropagation}
            aria-label={`${expanded ? 'Collapse' : 'Expand'} HP games`}
          >
            {expanded ? 'v' : '>'}
          </button>
        </div>
      </div>

      {expanded && (
        <div className="last-games-body">
          <LastHPMatchesTable data={filteredMatches.slice(0, limit)} />
        </div>
      )}
    </div>
  );
};

export default HPMatchDropdown;
